/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { StoresService } from "src/app/services/catalog/stores.service";
import { DialogService } from "src/app/services/dialog-service/dialog.service";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { SubSink } from "subsink";

@Component({
  selector: "app-side-nav",
  templateUrl: "./side-nav.component.html",
  styleUrls: ["./side-nav.component.scss"],
})
export class SideNavComponent implements OnInit {
  @ViewChild("target") mymodal: TemplateRef<any>;
  @Input() isProductHome;
  isLoggedIn = false;
  isSideNav = false;
  subsink = new SubSink();

  constructor(
    private router: Router,
    public dialogService: DialogService,
    public localStorageService: LocalStorageService,
    public storesService: StoresService,
    public slotService: SlotService,
    public cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.subsink.add(
      this.slotService.detachChangeListeners.subscribe((detach) => {
        if (!detach) this.cdRef.reattach();
        else this.cdRef.detach();
      })
    );
    if (
      localStorage.getItem("nVipaniwhiteshopkey") ||
      localStorage.getItem("retailerToken")
    ) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

  ngOnDestroy() {
    this.subsink.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.localStorageService.isMobileUpdate) {
      this.isSideNav = true;
      this.dialogService.openMatDialog(this.mymodal, {
        width: "100%",
        height: "100%",
        maxWidth: "100%",
      });
      this.localStorageService.isMobileUpdate = false;
    }
  }

  closeNavBar() {
    this.isSideNav = false;
    this.dialogService.dialog.closeAll();
  }

  checkSideNav(templateRef: TemplateRef<any>) {
    this.isSideNav = true;
    this.dialogService.openMatDialog(templateRef, {
      width: "100%",
      height: "100%",
      maxWidth: "100%",
    });
    this.ngOnInit();
  }

  isUserConsumer() {
    let index = -1;
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.companies && user.companies.length) {
      index = user.companies.findIndex((company) => company.consumer);
      if (index < 0 && user.type && user.type === "B2C") {
        index = 0;
      }
    }
    return index >= 0;
  }

  getCompanyLiveUrl() {
    let companyLiveUrl = "";
    if (!localStorage.getItem("widgetURL")) {
      let config = localStorage.getItem("config")
        ? JSON.parse(localStorage.getItem("config"))
        : JSON.parse(localStorage.getItem("companyConfig"));
      if (config && config.whiteshop && config.whiteshop.clickToCall) {
        companyLiveUrl = config.whiteshop.clickToCall.originUrl;
      }
    } else {
      companyLiveUrl = localStorage.getItem("widgetURL");
    }
    return companyLiveUrl;
  }

  logout() {
    let customerUrl = "";
    if (this.isUserConsumer()) {
      customerUrl = this.getCompanyLiveUrl();
    }
    localStorage.removeItem("nVipaniwhiteshopkey");
    localStorage.removeItem("nVipaniwhiteshopUser");
    localStorage.removeItem("userPic");
    this.localStorageService.resetUserData();
    this.storesService.notificationCount = 0;
    this.localStorageService.getConfig();
    this.router.navigateByUrl("/");
    this.closeNavBar();
    if (customerUrl) {
      window.location.assign(customerUrl);
    }
  }
}
